import React, { useRef, useState } from 'react'
import SelectMineralTypes from '../../../core/components/UI/SelectMineralTypes'
import SelectMultiMinerals from '../../../core/components/UI/SelectMultiMinerals'
import { MdCheck, MdClose } from 'react-icons/md'
import DatePickerSingle from '../../../core/components/UI/DatePickerSingle'
import { FaSpinner } from 'react-icons/fa'
import SelectOpportunityStatusTypes from '../../../core/components/UI/SelectOpportunityStatusTypes'
import useOpportunitiesActions from '../../hooks/useOpportunitiesActions'
import { useNavigate, useParams } from 'react-router-dom'
import { toastSuccess } from '../../../helper'

export default function FormCreateOpportunity() {
  const { country_id } = useParams()
  const navigate = useNavigate()
  const { createCountryOpportunity, inProgress } = useOpportunitiesActions()

  const [opportnityMineralsType, setOppornitytMineralsType] = useState(null)
  const [isExpired, setIsExpired] = useState(false)
  const opportnityTitleArRef = useRef(null)
  const opportnityTitleEnRef = useRef(null)
  const [mineralsIds, setMineralsIds] = useState(null)
  const rawMineralsArRef = useRef(null)
  const rawMineralsEnRef = useRef(null)
  const opportnityTypeArRef = useRef(null)
  const opportnityTypeEnRef = useRef(null)
  const [hasArea, setHasArea] = useState(true)
  const opportnityAreaRef = useRef(null)
  const [hasDate, setHasDate] = useState(true)
  const [opportnityDate, setOpportnityDate] = useState(null)
  const opportnityLinkRef = useRef(null)

  const getMineralLabels = (minerals, key, separator) =>
    minerals
      .filter((m) => m[key])
      .map((m) => m[key])
      .join(separator)

  function handleOnChangeMinerals(options) {
    if (!options?.length) return

    const text_ar = getMineralLabels(options, 'label', ' و')
    const text_en = getMineralLabels(options, 'name_en', ', ')
    const ids = getMineralLabels(options, 'value', ',')

    setMineralsIds(ids.split(','))
    rawMineralsArRef.current.value = text_ar
    rawMineralsEnRef.current.value = text_en
  }

  async function handleOnSubmitCreateOpportnityForm(event) {
    event.preventDefault()
    const formattedDate = new Date(opportnityDate)
      .toISOString()
      .slice(0, 19)
      .replace('T', ' ')
    const payload = {
      category_id: opportnityMineralsType,
      title_ar: opportnityTitleArRef.current.value,
      title_en: opportnityTitleEnRef.current.value,
      minerals_ids: mineralsIds,
      raw_materials_ar: rawMineralsArRef.current.value,
      raw_materials_en: rawMineralsEnRef.current.value,
      type_ar: opportnityTypeArRef.current.value,
      type_en: opportnityTypeEnRef.current.value,
      area: hasArea ? opportnityAreaRef.current.value : null,
      started_at: hasDate ? formattedDate : null,
      attachment_link: opportnityLinkRef.current.value,
      is_expired: isExpired,
    }
    console.log(payload)

    const message = await createCountryOpportunity(country_id, payload)
    if (message) {
      toastSuccess(message)
      navigate(`/countries/opportunities`)
    }
  }

  return (
    <form
      onSubmit={handleOnSubmitCreateOpportnityForm}
      className="flex flex-col gap-4"
    >
      <div className="flex gap-4">
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_OPPORTNITY_TYPE"
          >
            صنف المعادن<span className="text-danger-600">*</span>
          </label>
          <SelectMineralTypes
            onChange={(value) => setOppornitytMineralsType(value)}
          />
        </div>
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_OPPORTNITY_IS_EXPIRED"
          >
            حالة الفرصة <span className="text-danger-600">*</span>
          </label>
          <SelectOpportunityStatusTypes
            onChange={(value) => setIsExpired(value)}
            defaultValue={isExpired}
          />
        </div>
      </div>
      <div className="flex gap-4">
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_OPPORTNITY_TITLE_AR"
          >
            عنوان بالعربية <span className="text-danger-600">*</span>
          </label>
          <input
            id="ID_OPPORTNITY_NAME_AR"
            ref={opportnityTitleArRef}
            type="text"
            className="border-2 border-muted-500 px-4 py-2 leading-none outline-none"
          />
        </div>
        <div className="flex w-full flex-col gap-1">
          <label
            className="line-clamp-1 font-bold"
            htmlFor="ID_OPPORTNITY_TITLE_EN"
          >
            عنوان بالإنجليزية
          </label>
          <input
            id="ID_OPPORTNITY_NAME_EN"
            ref={opportnityTitleEnRef}
            type="text"
            className="border-2 border-muted-500 px-3 py-2 leading-none outline-none"
          />
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex w-full flex-col gap-1">
          <label
            className="line-clamp-1 font-bold"
            htmlFor="ID_OPPORTNITY_RAW_MINERALS_ID"
          >
            الخامات <span className="text-danger-600">*</span>
          </label>
          <SelectMultiMinerals onChange={handleOnChangeMinerals} />
        </div>
        <div className="flex gap-4">
          <input
            id="ID_OPPORTNITY_RAW_MINERALS_AR"
            ref={rawMineralsArRef}
            type="text"
            className="w-full border-2 border-muted-500 px-3 py-2 leading-none outline-none"
          />
          <input
            dir="ltr"
            id="ID_OPPORTNITY_RAW_MINERALS_EN"
            ref={rawMineralsEnRef}
            type="text"
            className="w-full border-2 border-muted-500 px-3 py-2 leading-none outline-none"
          />
        </div>
      </div>
      <div className="flex gap-4">
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_OPPORTNITY_TYPE_AR"
          >
            نوع بالعربية
            <span className="text-danger-600">*</span>
          </label>
          <input
            id="ID_OPPORTNITY_TYPE_AR"
            ref={opportnityTypeArRef}
            type="text"
            className="border-2 border-muted-500 px-4 py-2 leading-none outline-none"
          />
        </div>
        <div className="flex w-full flex-col gap-1">
          <label
            className="line-clamp-1 font-bold"
            htmlFor="ID_OPPORTNITY_TYPE_EN"
          >
            نوع بالإنجليزية
          </label>
          <input
            dir="ltr"
            id="ID_OPPORTNITY_TYPE_EN"
            ref={opportnityTypeEnRef}
            type="text"
            className="border-2 border-muted-500 px-3 py-2 leading-none outline-none"
          />
        </div>
      </div>
      <div className="flex gap-4">
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_OPPORTNITY_AREA"
          >
            المساحة (كم<sup>2</sup>)
          </label>
          <div className="flex">
            <input
              disabled={!hasArea}
              id="ID_OPPORTNITY_AREA"
              ref={opportnityAreaRef}
              type="number"
              inputMode="decimal"
              step="any"
              className="w-full border-2 border-l-0 border-muted-500 px-4 py-2 leading-none outline-none disabled:bg-muted-100"
            />
            <button
              type="button"
              onClick={() => setHasArea(!hasArea)}
              className={`flex border-2 ${!hasArea ? 'border-success-600 bg-success-500' : 'border-danger-600 bg-danger-500'} px-4 py-2 text-white`}
            >
              {!hasArea ? <MdCheck size={22} /> : <MdClose size={22} />}
            </button>
          </div>
        </div>
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_OPPORTNITY_CREATE_AT"
          >
            تاريخ الفرصة
          </label>
          <div className="flex">
            {hasDate ? (
              <DatePickerSingle
                onChange={(date) => setOpportnityDate(date)}
                id="ID_OPPORTNITY_CREATE_AT"
              />
            ) : (
              <div className="h-full w-full border-2 border-l-0 border-muted-500 bg-muted-100" />
            )}
            <button
              type="button"
              onClick={() => setHasDate(!hasDate)}
              className={`flex border-2 ${!hasDate ? 'border-success-600 bg-success-500' : 'border-danger-600 bg-danger-500'} px-4 py-2 text-white`}
            >
              {!hasDate ? <MdCheck size={22} /> : <MdClose size={22} />}
            </button>
          </div>
        </div>
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_OPPORTNITY_LINK"
        >
          رابط معلومات إضافية
        </label>
        <input
          dir="ltr"
          id="ID_OPPORTNITY_LINK"
          ref={opportnityLinkRef}
          type="url"
          placeholder="https://..."
          className="border-2 border-muted-500 px-4 py-2 leading-none outline-none"
        />
      </div>
      <button
        type="submit"
        disabled={inProgress}
        className="flex w-full items-center justify-center gap-2 border-2 border-primary-600 bg-primary-600 px-6 py-3 font-bold text-white outline-none hover:border-accent-600 hover:bg-accent-600 disabled:cursor-not-allowed disabled:border-muted-500 disabled:bg-muted-300 disabled:text-primary-600"
      >
        {inProgress ? (
          <>
            <FaSpinner
              size={16}
              className="animate-spin"
            />
            <span>جاري إضافة فرصة...</span>
          </>
        ) : (
          <span>إضافة فرصة</span>
        )}
      </button>
    </form>
  )
}
